<template>
  <v-dialog v-model="dialog" max-width="400" persistent>
    <v-card class="rounded-lg" flat>
      <v-card-title class="headline pa-6 justify-center">
        {{ title }}
      </v-card-title>
      <v-card-text class="pa-4 text-center grey--text text--darken-3">
        {{ description }}
      </v-card-text>
      <v-card-actions class="pa-4">
        <v-spacer />
        <v-btn
          color="#2661FF"
          outlined
          min-width="100px"
          @click="$emit('close')"
        >
          {{ cancelText }}
        </v-btn>
        <v-btn
          :loading="acceptLoading"
          color="#2661FF"
          min-width="100px"
          @click="$emit('proceed')"
        >
          <span class="white--text">{{ acceptText }}</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'BaseConfirmDialog',
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    cancelText: {
      type: String,
      required: true
    },
    acceptText: {
      type: String,
      required: true
    },
    acceptLoading: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({ dialog: true })
}
</script>
